import { render, staticRenderFns } from "./RichText_v1.vue?vue&type=template&id=e449f618&scoped=true&lang=pug"
import script from "./RichText_v1.vue?vue&type=script&lang=js"
export * from "./RichText_v1.vue?vue&type=script&lang=js"
import style0 from "./RichText_v1.vue?vue&type=style&index=0&id=e449f618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e449f618",
  null
  
)

export default component.exports